module.exports = __webpack_public_path__ + "img/Professional-1.c1b9d01a.gif";